import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { rem } from 'polished';
import TableV2 from '../../../../Components/Table';
import { __, /*formatPrice,*/ translateLayer } from '../../../../Utils';
import { RouteLinkWraper } from '../../../../Components/ReusableComponents';
// import CartIcon from './cart.svg';

const MainWrapper = styled.div``;

const StyledLink = styled(Link)`
  color: '#70af00';
`;

const StyledHeader = styled.div`
  display: flex;
  margin-left: 4px;
  font-weight: bold;
  font-size: 18px;
  color: #434245;
  margin-top: 15px;
`;

const StyledTd = styled.div`
  display: flex;
  margin-left: 10px;
  margin-top: 8px;
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 14px;
  color: #434245;
`;

// const AddToCardWrapper = styled.div`
//   height: ${rem(32)};
//   width: ${rem(32)};
//   background: #70af00;
//   border-radius: ${rem(2)};
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;

class PaintSystemsProducts extends React.Component {
  createColumns() {
    return [
      {
        accessor: 'layer',
        Header: () => <StyledHeader>{__('VRSTVA')}</StyledHeader>,
        Cell: props => {
          return <StyledTd>{translateLayer(props.value)}</StyledTd>;
        },
      },

      // {
      //   accessor: 'ean',
      //   Header: () => <StyledHeader>{__('EAN')}</StyledHeader>,
      //   maxWidth: 130,
      //   Cell: props => {
      //     return <StyledTd>{props.value}</StyledTd>;
      //   },
      // },

      // {
      //   accessor: '_id',
      //   Header: () => <StyledHeader>{__('ČÍSLO')}</StyledHeader>,
      //   maxWidth: 130,
      //   Cell: props => {
      //     return <StyledTd>{props.value}</StyledTd>;
      //   },
      // },

      {
        accessor: 'name',
        Header: () => <StyledHeader>{__('NÁZOV')}</StyledHeader>,
        minWidth: 180,
        Cell: props => {
          return (
            <StyledTd>
              <RouteLinkWraper fontSize={rem(14)} noMargin color="#70af00">
                <StyledLink to={`/catalog/list/${props.original._id}`}>
                  {props.value}
                </StyledLink>
              </RouteLinkWraper>
            </StyledTd>
          );
        },
      },

      // {
      //   accessor: 'on_stock',
      //   minWidth: 110,
      //   Header: () => <StyledHeader>{__('ZÁSOBY K DÁTUMU')}</StyledHeader>,
      //   Cell: props => {
      //     return <StyledTd>{props.value}</StyledTd>;
      //   },
      // },

      // {
      //   accessor: 'price',
      //   Header: () => (
      //     <StyledHeader>{__('DOPORUČENÁ CENA BEZ DPH')}</StyledHeader>
      //   ),
      //   minWidth: 180,
      //   Cell: props => {
      //     return <StyledTd>{props.value && formatPrice(props.value)}</StyledTd>;
      //   },
      // },

      {
        accessor: 'hsf',
        minWidth: 30,
        Header: () => <StyledHeader>{__('HSF')}</StyledHeader>,
        Cell: props => {
          return (
            <StyledTd>{`${props.value} ${props.original.hsf_unit ||
              ''}`}</StyledTd>
          );
        },
      },
    ];
  }

  render() {
    const { data, onVariantSelect, selectedVariantIndex, loading } = this.props;

    return (
      <MainWrapper>
        <TableV2
          columns={this.createColumns()}
          minWidth={10}
          loading={loading}
          loadingColor="#70af00"
          data={data}
          pageSize={data.length}
          getTrProps={(state, rowInfo) => {
            if (rowInfo && rowInfo.row) {
              return {
                onClick: () => onVariantSelect(rowInfo.index),
                style: {
                  border:
                    rowInfo.index === selectedVariantIndex
                      ? '#70af00 solid 1px'
                      : rowInfo.index % 2 === 0
                      ? 'white'
                      : '#eee',
                  color:
                    rowInfo.index === selectedVariantIndex ? 'white' : 'black',
                  cursor: 'pointer',
                },
              };
            }
            return {};
          }}
          getTdProps={() => {
            return { style: { padding: 0, margin: 'auto', border: 0 } };
          }}
          getTheadThProps={(state, rowInfo, column) => {
            return {
              style: { border: 0 },
            };
          }}
          className="-highlight -striped"
          offset={120}
        />
      </MainWrapper>
    );
  }
}

PaintSystemsProducts.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      layer: PropTypes.number,
      _id: PropTypes.string,
      ean: PropTypes.string,
      name: PropTypes.string,
      volume: PropTypes.string,
      on_stock: PropTypes.number,
      hsf: PropTypes.number,
      hsf_unit: PropTypes.string,
      price: PropTypes.shape({}),
    }),
  ),
  onVariantSelect: PropTypes.func,
  addToCart: PropTypes.func,
  loading: PropTypes.bool,
  selectedVariantIndex: PropTypes.number,
};

PaintSystemsProducts.defaultProps = {
  data: [],
  onVariantSelect: () => {},
  addToCart: () => {},
  loading: false,
  selectedVariantIndex: -1,
};

export default PaintSystemsProducts;



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Components/Products/index.jsx